/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    InventoryVm,
    InventoryVmFromJSON,
    InventoryVmFromJSONTyped,
    InventoryVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface InventoryVmPaginatedSearchResponse
 */
export interface InventoryVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<InventoryVm>}
     * @memberof InventoryVmPaginatedSearchResponse
     */
    items?: Array<InventoryVm> | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryVmPaginatedSearchResponse
     */
    size?: number;
}

export function InventoryVmPaginatedSearchResponseFromJSON(json: any): InventoryVmPaginatedSearchResponse {
    return InventoryVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function InventoryVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InventoryVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(InventoryVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function InventoryVmPaginatedSearchResponseToJSON(value?: InventoryVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(InventoryVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


